module.exports = __webpack_public_path__ + "img/6.0914de9a.jpg";